import gql from "graphql-tag";

export const REFRESH_TOKEN = gql`
  mutation MyMutation($refreshToken: String = "") {
    userRefreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
      data {
        profileId
        userId
      }
    }
  }
`;
